// src/design-system/data-table/DataTablePagination.tsx
import { Button } from "@/components/ui/button";

type Props = {
  page: number;
  canGoNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
};

export function DataTablePagination({
  page,
  canGoNext,
  onPrevious,
  onNext,
}: Props) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <Button
        type="button"
        variant="secondary"
        disabled={page <= 1}
        onClick={onPrevious}
      >
        Previous
      </Button>

      <p className="text-sm text-slate-400">Page {page}</p>

      <Button
        type="button"
        variant="secondary"
        disabled={!canGoNext}
        onClick={onNext}
      >
        Next
      </Button>
    </div>
  );
}
